import STEPS from '../content/steps';
import Reveal from './Reveal';

export default function ProcessSteps() {
  return (
    <section id="process" aria-labelledby="process-h" className="bg-ink text-bg">
      <div className="container-site border-b-2 border-neutral-800 py-sec-y">
        <Reveal className="flex flex-wrap items-end justify-between gap-x-10 gap-y-6 border-b-2 border-neutral-700 pb-7">
          <h2 id="process-h" className="text-h2">How we work</h2>
          <p className="max-w-[380px] text-body text-neutral-300">Working software every two weeks. No six-month silences.</p>
        </Reveal>
        <ol className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))' }}>
          {STEPS.map(st => (
            <Reveal as="li" key={st.n} className="border-b-2 border-neutral-700 pb-2 pr-6 pt-8">
              <div className="text-step text-accent">{st.n}</div>
              <div className="mt-7 text-[13px] font-semibold uppercase tracking-[0.08em] text-neutral-400">{st.time}</div>
              <h3 className="mt-2 text-[24px] leading-[1.1] tracking-[-0.02em]">{st.title}</h3>
              <p className="pretty mb-6 mt-2.5 text-[16px] text-neutral-300">{st.desc}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
